/**
 *
 * Asynchronously loads the component for OrderConfirmation
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
